import HBSwiper from "@/components/HBSwiper";
import Image from "@/components/Image";
import { useSearchLimit } from "@/components/LoginModal/useLoginLimit";
import { setSearch } from "@/tracker/shared/global";
import { getImageSrc2x } from "@/utils/imageUrl";
import { useMemoizedFn, useUpdateEffect } from "ahooks";
import classNames from "classnames";
import { useRouter } from "next/router";
import QueryString from "qs";
import { useRef } from "react";
import styles from "./index.module.less";

export function RelationWords({ relationList }) {
  const router = useRouter();

  const { q, sort, type, filterIds } = router.query;

  const { onSearchLimitCheck } = useSearchLimit();

  const getNextQuery = useMemoizedFn((word: string) => {
    return {
      q: `${q} ${word}`,
      ...(sort ? { sort } : null),
      ...(type ? { type } : null),
      ...(filterIds ? { filter_ids: filterIds } : null),
    };
  });

  const onClickKeyword = useMemoizedFn(async (evt, keyWord) => {
    evt.preventDefault();

    await onSearchLimitCheck();

    setSearch({
      search_word_type: "搜索推荐词",
    });
    const query = getNextQuery(keyWord);
    router.push(
      {
        pathname: "/search",
        query,
      },
      undefined,
      {
        // 如果当前页面pathname没变化则不需要执行服务端方法
        shallow: router.pathname === "/search",
      }
    );
  });

  const swiperRef = useRef(null);
  useUpdateEffect(() => {
    // 内容更新，滚动到顶部
    swiperRef.current?.reset();
  }, [relationList]);

  if (!(relationList?.length > 0)) {
    return null;
  }

  return (
    <div className={classNames(styles.swiperContent, styles.new)}>
      <HBSwiper
        className={styles.swiper}
        iconClassName={styles.icon}
        ref={swiperRef}
      >
        <div className={styles.list}>
          {relationList.map((item, index) => (
            <a
              key={index}
              className={styles.searchCard}
              onClick={(evt) => onClickKeyword(evt, item.word)}
              href={`/search?${QueryString.stringify(getNextQuery(item.word))}`}
              data-gd-expose="button_expose"
              data-gd-click="button_click"
              data-button-name={item.word}
              data-content-source="搜索推荐词"
              data-unique-id={item.word}
            >
              {item.file && (
                <Image
                  {...getImageSrc2x(item.file, { width: 32 })}
                  alt={item.word}
                  width={32}
                  height={32}
                />
              )}
              {item.word}
            </a>
          ))}
        </div>
      </HBSwiper>
    </div>
  );
}
